import React from 'react';
import { useTranslate } from '@hooks';
import { genders } from '@dotone/react-ui-core/constants';
import { camelCase } from 'lodash';
import { UncontrolledTooltip } from 'reactstrap';
import GenderMale from 'mdi-react/GenderMaleIcon';
import GenderFemale from 'mdi-react/GenderFemaleIcon';
import GenderNonBinary from 'mdi-react/GenderNonBinaryIcon';
import GenderTransgender from 'mdi-react/GenderTransgenderIcon';

const AffiliateGenderIcon = ({ value, id, ...otherProps }) => {
  const { t } = useTranslate('affiliate', 'gender');

  let Icon;
  if (value === genders.WOMAN) {
    Icon = GenderFemale;
  } else if (value === genders.MAN) {
    Icon = GenderMale;
  } else if (value === genders.NON_BINARY) {
    Icon = GenderNonBinary;
  } else if (value === genders.TRANSGENDER) {
    Icon = GenderTransgender;
  } else {
    return null;
  }

  return (
    <>
      <Icon id={id} {...otherProps} />
      <UncontrolledTooltip target={id}>{t(camelCase(value))}</UncontrolledTooltip>
    </>
  );
};

export default AffiliateGenderIcon;
